import React from 'react';
import styled from 'styled-components';
import MotifToast from '@ey/motif-react-wrapper/Toast';

export default function Toast(props) {
	const {id, position, className, onClose, variant, children, actions, ...rest} = props;
	return (
		<StyledMotifToast actions={actions} id={id} position={position} variant={variant} className={className} onClose={onClose} {...rest}>
			{children}
		</StyledMotifToast>
	);
}

const StyledMotifToast = styled(MotifToast)``;
